const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    actions: {
        backgroundColor: theme.palette.background.paper
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    formLabel: {
        borderRadius: 2,
        backgroundColor: theme.palette.background.paper,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'gainsboro',
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.primary
    }
});

export default styles;